exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".md-table-head.end[data-v-160834d9] {\n  text-align: right;\n}\n[data-v-160834d9] .md-table-cell.action-buttons {\n  padding-right: 30px;\n  text-align: right;\n}\n", ""]);

// exports
